import { Link } from 'react-router';

import logoSrc from '@/assets/brand/brucepets-logo.jpeg';
import { SITE } from '@/config/site';
import { cn } from '@/lib/cn';

interface LogoProps {
  className?: string;
  /** Renders as a plain image — for use inside an existing link. */
  static?: boolean;
}

/**
 * The BrucePets mark.
 *
 * The client's feedback on the first draft was that the logo felt small and
 * cramped, so it is sized generously here and the wordmark is never repeated
 * as a heading elsewhere on the page.
 */
export function Logo({ className, static: isStatic = false }: LogoProps) {
  const image = (
    <img
      src={logoSrc}
      alt={`${SITE.name} — ${SITE.tagline}`}
      width={220}
      height={220}
      className={cn('h-16 w-auto object-contain lg:h-20', className)}
    />
  );

  if (isStatic) return image;

  return (
    <Link
      to="/"
      className="shrink-0 rounded-xl transition-transform duration-300 hover:scale-[1.03]"
      aria-label={`${SITE.name} — página inicial`}
    >
      {image}
    </Link>
  );
}
